module.exports = __webpack_public_path__ + "static/media/wavm8s-023-klahrk-talbot.539a0f8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-023-klahrk-talbot.mp3
// module id = dUKz
// module chunks = 0